export const calculatePrice = {
    helicopterCO: 0.006,     // 6 divide on kiloToneCO: 1000
    droneCO: 0.0015,         // 1.5 divide on kiloToneCO: 1000
    satellitePrice: 5,       // dollar
    satellitePriceEuro: 3,   // euro
    helicopterTime: 4,       // time => weeks
    droneTime: 3.5,          // time => weeks
    satelliteTime: 0.001,    // time => weeks
    moreThan: 999.999,       // toggle thousands and millions
}